/* ============================================================
   Japanese Chill - Custom Scripts (jc-custom.js)
   ============================================================ */

'use strict';

// 複数セクションから読み込まれても初期化は1回だけ実行する
if (window.__jcCustomInit) { throw new Error('jc-custom: already loaded'); }
window.__jcCustomInit = true;

// ---------- FAQ Accordion ----------
(function initFaq() {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.jc-faq__question');
    if (!btn) return;

    const item = btn.closest('.jc-faq__item');
    if (!item) return;

    const isOpen = item.classList.contains('is-open');

    // Close all open items in the same FAQ container
    const faqContainer = item.closest('.jc-faq');
    if (faqContainer) {
      faqContainer.querySelectorAll('.jc-faq__item.is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
      });
    }

    if (!isOpen) {
      item.classList.add('is-open');
    }
  });
})();

// ---------- Mobile Sticky CTA Bar ----------
(function initStickyBar() {
  const bar = document.querySelector('.jc-sticky-bar');
  if (!bar) return;

  const originalBtn = document.querySelector('.jc-sticky-bar__trigger');

  // Show bar after scrolling past the original add-to-cart button
  function checkVisibility() {
    if (!originalBtn) {
      bar.classList.add('is-visible');
      return;
    }

    const rect = originalBtn.getBoundingClientRect();
    const pastOriginal = rect.bottom < 0;
    bar.classList.toggle('is-visible', pastOriginal);
  }

  window.addEventListener('scroll', checkVisibility, { passive: true });
  checkVisibility();

  // Clicking sticky bar button submits the product form
  const stickyBtn = bar.querySelector('.jc-sticky-bar__btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      const form = document.querySelector('form[action="/cart/add"]');
      if (form) {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      } else {
        const mainBtn = document.querySelector('.jc-sticky-bar__trigger');
        if (mainBtn) mainBtn.click();
      }
    });
  }
})();

// ---------- Smooth scroll for anchor links ----------
(function initSmoothScroll() {
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;

    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

// ---------- Product Gallery ----------
(function initGallery() {
  const mainImg = document.getElementById('jc-main-img');
  const thumbs = document.querySelectorAll('.jc-product-gallery__thumb');
  if (!mainImg || !thumbs.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Preload all gallery images so switching is instant
  thumbs.forEach(function (thumb) {
    var pre = new Image();
    pre.src = thumb.dataset.src;
  });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (thumb.classList.contains('is-active')) return;

      const newSrc = thumb.dataset.src;
      const newAlt = thumb.dataset.alt;

      // Update active state
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-current', 'false');
      });
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');

      if (reducedMotion) {
        mainImg.src = newSrc;
        mainImg.alt = newAlt;
      } else {
        mainImg.classList.add('is-switching');
        setTimeout(function () {
          mainImg.src = newSrc;
          mainImg.alt = newAlt;
          mainImg.classList.remove('is-switching');
        }, 250);
      }
    });
  });
})();

// ---------- Variant Picker ----------
(function initVariantPicker() {
  const variantBtns = document.querySelectorAll('.jc-variant-btn');
  if (!variantBtns.length) return;

  const productData = window.jcProductData;
  if (!productData) return;

  const variants = productData.variants;
  const variantPrices = productData.variantPrices;

  // Build initial selectedOptions from current button states
  const selectedOptions = {};
  variantBtns.forEach(function (btn) {
    if (btn.classList.contains('is-selected')) {
      selectedOptions[btn.dataset.optionIndex] = btn.dataset.value;
    }
  });

  function findMatchingVariant() {
    return variants.find(function (variant) {
      return variant.options.every(function (val, i) {
        return selectedOptions[String(i)] === val;
      });
    });
  }

  function updatePriceUI(variantId) {
    const prices = variantPrices[String(variantId)];
    if (!prices) return;

    const currentEl = document.getElementById('jc-price-current');
    const compareEl = document.getElementById('jc-price-compare');
    const badgeEl = document.getElementById('jc-price-badge');

    if (currentEl) {
      currentEl.textContent = prices.price;
      currentEl.classList.toggle('jc-price__current--sale', !!prices.compare_at_price);
    }

    if (compareEl) {
      if (prices.compare_at_price) {
        compareEl.textContent = prices.compare_at_price;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
      }
    }

    if (badgeEl) {
      if (prices.compare_at_price) {
        // Extract raw numbers to compute pct (prices are already formatted strings)
        const rawVariant = variants.find(function (v) { return String(v.id) === String(variantId); });
        if (rawVariant && rawVariant.compare_at_price > rawVariant.price) {
          const pct = Math.round((rawVariant.compare_at_price - rawVariant.price) * 100 / rawVariant.compare_at_price);
          badgeEl.textContent = '-' + pct + '%';
          badgeEl.hidden = false;
        } else {
          badgeEl.hidden = true;
        }
      } else {
        badgeEl.hidden = true;
      }
    }
  }

  function updateAtcBtn(available) {
    const btn = document.getElementById('jc-atc-btn');
    if (!btn) return;
    btn.disabled = !available;
    btn.textContent = available ? 'カートに追加' : '売り切れ';
  }

  function updateStickyBar(variantId, available) {
    const bar = document.querySelector('.jc-sticky-bar');
    if (!bar) return;

    const prices = variantPrices[String(variantId)];
    const priceEl = bar.querySelector('.jc-sticky-bar__price');
    const stickyBtn = bar.querySelector('.jc-sticky-bar__btn');

    if (priceEl && prices) {
      priceEl.textContent = prices.price;
    }

    if (stickyBtn) {
      stickyBtn.disabled = !available;
      stickyBtn.textContent = available ? 'カートに追加' : '売り切れ';
    }
  }

  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const optionIndex = btn.dataset.optionIndex;
      const value = btn.dataset.value;

      // Update selected state for this option group
      document.querySelectorAll('.jc-variant-btn[data-option-index="' + optionIndex + '"]').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-checked', 'true');

      selectedOptions[optionIndex] = value;

      const matched = findMatchingVariant();
      if (!matched) return;

      // Update hidden input
      const variantInput = document.getElementById('jc-variant-id');
      if (variantInput) variantInput.value = matched.id;

      // Update URL without reloading
      const url = new URL(window.location.href);
      url.searchParams.set('variant', matched.id);
      window.history.replaceState({}, '', url.toString());

      updatePriceUI(matched.id);
      updateAtcBtn(matched.available);
      updateStickyBar(matched.id, matched.available);
    });
  });
})();

// ---------- Quantity Selector ----------
(function initQtySelector() {
  const minusBtn = document.getElementById('jc-qty-minus');
  const plusBtn = document.getElementById('jc-qty-plus');
  const input = document.getElementById('jc-qty-input');
  if (!minusBtn || !plusBtn || !input) return;
  if (input.dataset.qtyInit) return;
  input.dataset.qtyInit = '1';

  function clampValue(val) {
    return Math.max(1, parseInt(val, 10) || 1);
  }

  minusBtn.addEventListener('click', function () {
    input.value = clampValue(input.value) - 1;
    if (parseInt(input.value, 10) < 1) input.value = 1;
  });

  plusBtn.addEventListener('click', function () {
    input.value = clampValue(input.value) + 1;
  });

  input.addEventListener('change', function () {
    input.value = clampValue(input.value);
  });
})();
